import axiosInstance from '../../axiosInstance';

const updateDesktopStreamThumbnail = async (image, stream_key = 'default') => {
  try {
    // eslint-disable-next-line no-undef
    const formData = new FormData();
    formData.append('image', image);

    const response = await axiosInstance.patch(
      `/api/admin/v2/streams/${stream_key}/desktop-thumbnail`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    const responseData = response.data;

    if (responseData.error) {
      throw new Error(responseData.error.errorMessage);
    }

    return responseData.data.imageUrl;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export default updateDesktopStreamThumbnail;
